import { Link } from "react-router-dom";
import PhoneIcon from "../../icons/phoneIcon";
import MailIcon from "../../icons/mailIcon";
import LocationFooterIcon from "../../icons/locationFooterIcon";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Popup from "../popups/popup";
import BeOurAgent from "./beOurAgent/beOurAgent";

const Footer = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  // =========================
  // 📦 CONTACT INFO STATE
  // =========================
  const [contactInfo, setContactInfo] = useState(null);

  // =========================
  // 📥 FETCH WEB DATA
  // =========================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("https://ba7ary.draconiccode.com/public/api/web-data", {
          headers: {
            Accept: "application/json",
          },
        });

        const data = await res.json();
        setContactInfo(data);
      } catch (error) {
        console.log("Footer API error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <footer
      style={{
        backgroundImage:
          "linear-gradient(87.6deg, #27255A -0.29%, #544FC0 93.18%)",
      }}
    >
      <div className="justify-between block w-11/12 py-8 mx-auto space-y-4 text-white md:space-y-0 md:flex">

        {/* ========================= */}
        {/* COMPANY */}
        {/* ========================= */}
        <div>
          <h2 className="text-xl font-bold">{t("ourCompany")}</h2>

          <Link className="block my-1 text-lg underline-link w-fit" to="about-Us">
            {t("about")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="blog">
            {t("blog")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="contact-us">
            {t("contact")}
          </Link>

          <button
            onClick={() => setOpen(true)}
            className="block my-1 text-lg underline-link w-fit"
          >
            {t("beAgent")}
          </button>
        </div>

        {/* ========================= */}
        {/* SUPPORT */}
        {/* ========================= */}
        <div>
          <h2 className="text-xl font-bold">{t("support")}</h2>

          <Link className="block my-1 text-lg underline-link w-fit" to="FAQs">
            {t("FAQs")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="terms-&-conditions">
            {t("termsCondition")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="privacy-policy">
            {t("privacyPolicy")}
          </Link>

          <Link
            className="block my-1 text-lg underline-link w-fit"
            to="https://www.marinetraffic.com/en/ais/home/centerx:-5.6/centery:27.6/zoom:4"
          >
            {t("trackShipment")}
          </Link>
        </div>

        {/* ========================= */}
        {/* SERVICES */}
        {/* ========================= */}
        <div>
          <h2 className="text-xl font-bold">{t("ourServices")}</h2>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/sea-transportation">
            {t("seaShipping")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/air-transportation">
            {t("airShipping")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/land-transportation">
            {t("landShipping")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/customs-clearance">
            {t("customClearance")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/ship-rental">
            {t("shipRental")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/train-transportation">
            {t("shippingByTrains")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/caching">
            {t("caching")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/production-logistics">
            {t("productionLogistics")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/dangerous-goods">
            {t("dangerousGoodsTransport")}
          </Link>

          <Link className="block my-1 text-lg underline-link w-fit" to="/services/partial-transport">
            {t("partialTransport")}
          </Link>
        </div>

        {/* ========================= */}
        {/* CONTACT INFO (API) */}
        {/* ========================= */}
        <div>
          <h2 className="text-xl font-bold">{t("contactInfo")}</h2>

          {/* LOCATION */}
          <p className="flex items-center gap-2 my-[14px] text-lg">
            <LocationFooterIcon />
            {contactInfo?.location?.value || "بين اسيا والبحر الابيض المتوسط، مرسين"}
          </p>

          {/* PHONE */}
          <a
            href={`tel:${contactInfo?.phone?.value || "+905527977772"}`}
            className="flex items-center gap-2 my-[14px] text-lg hover:underline"
          >
            <PhoneIcon />
            {contactInfo?.phone?.value || "+90 552 797 77 72"}
          </a>

          {/* EMAIL */}
          <a
            href={`mailto:${contactInfo?.email?.value || "info@megtlogistics.com"}`}
            className="flex items-center gap-2 my-[14px] text-lg hover:underline"
          >
            <MailIcon />
            {contactInfo?.email?.value || "info@megtlogistics.com"}
          </a>
        </div>
      </div>
        <div className="border-t border-white/5 py-8 text-center text-[#c4c6d1] text-sm relative z-10 px-4">
          © 2026 <a href="https://draconiccode.com">DraconicCode</a>. All Rights Reserved. Building Digital Solutions That Drive Success.
        </div>

      {/* POPUP */}
      <Popup state={open} setState={setOpen} title={t("beAgent")}>
        <BeOurAgent />
      </Popup>
    </footer>
  );
};

export default Footer;